<template>
    <div class="relative mt-auto flex justify-between flex-nowrap">
        <div class="relative bord-item"
            v-for="(i, index) in 5"
            :key="index"
        >
            <div
                class="mb-[-10px] h-0 pt-[100%] relative z-[1]"
                :class="animateEnable ? 'floatAnimate' : ''"
                :style="{ animationDelay: animateEnable ? `${i * 0.9}s` : '' }"
            >
                <q-img
                    class="left-1/2 z-10 top-1/2 translate-x-[-50%] translate-y-[-50%] absolute"
                    alt=""
                    :src="getCryptosImg(index)"
                />
            </div>
            <div class="relative">
                <div
                    v-if="getCryptosImg(index) !== undefined"
                    class="absolute inset-0 opacity-[0.85] scale-1.025"
                >
                    <svg
                        viewBox="0 0 77 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-[70%] absolute inset-0 m-auto"
                    >
                        <path
                            d="M76.94 6.6c0 3.65-17.23 6.6-38.47 6.6C17.22 13.2 0 10.25 0 6.6 0 2.96 17.22 0 38.47 0 59.7 0 76.94 2.96 76.94 6.6z"
                            fill="url(#cryptos-radial)"
                            opacity=".25"
                        ></path>
                        <defs>
                            <radialGradient
                                id="cryptos-radial"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientUnits="userSpaceOnUse"
                                gradientTransform="matrix(0 6.60204 -38.469 0 38.47 6.6)"
                            >
                                <stop offset=".65" stop-color="#000"></stop>
                                <stop offset="1" stop-color="#000" stop-opacity="0"></stop>
                            </radialGradient>
                        </defs>
                    </svg>
                </div>
                <img class="w-full" :src="getCryptoBottoImg(index)" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
let cryptosImgs = ref({});
let cryptosBottomImgs = ref({});

const props = defineProps({
    roll_number: {
        type: Array,
        required: true,
    },
    level: {
        type: Number,
        required: true,
    },
    frequencies: {
        type: Object,
        required: true,
    },
    animateEnable: {
        type: Boolean,
        required: true,
    },
});
/**
 * 获取对应的开奖img
 * @param index 下标
 */
const getCryptosImg = (index) => {
    const number = props.roll_number.find((item, i) => {
        return i === index;
    }) as any;

    return cryptosImgs.value[number];
};
/**
 * 获取底部图片
 * @param index 下标
 */
const getCryptoBottoImg = (index) => {
    const cryptosImgNumber = props.roll_number.find((item, i) => {
        return i === index;
    }) as any;

    const keys = Object.keys(props.frequencies);

    const isMatch = keys.find((item) => item == cryptosImgNumber);

    return cryptosBottomImgs.value[isMatch ? isMatch : 8];
};

onMounted(() => {
    //  get all cryptosImg
    let folderImgs = import.meta.glob(`~/pages/casino/cryptosGame/img/cryptos/*.svg`, {
        eager: true,
    });
    const folderImgList = Object.entries(folderImgs).map(([key, value]) => {
        const gameName = key
            .replace(`/pages/casino/cryptosGame/img/cryptos/`, '')
            .replace(/\.(png|svg|jpg|webp)*/g, '');
        return [gameName, (value as { default: any }).default];
    });

    cryptosImgs.value = Object.fromEntries(folderImgList);

    let folderBottomImgs = import.meta.glob(`~/pages/casino/cryptosGame/img/cryptosBottom/*.svg`, {
        eager: true,
    });
    const folderBottomImgList = Object.entries(folderBottomImgs).map(([key, value]) => {
        const gameName = key
            .replace(`/pages/casino/cryptosGame/img/cryptosBottom/`, '')
            .replace(/\.(png|svg|jpg|webp)*/g, '');
        return [gameName, (value as { default: any }).default];
    });

    cryptosBottomImgs.value = Object.fromEntries(folderBottomImgList);
});
</script>

<style lang="scss" scoped>
.floatAnimate {
    animation: float 1.5s ease-in-out infinite;
}
.bord-item {
    margin: 0 2%;
    &:first-child {
        margin-left: 0;
    }
    &:last-child {
        margin-right: 0;
    }
}
@keyframes float {
    0% {
        transform: translateY(2%);
    }
    50% {
        transform: translateY(-2%);
    }
    100% {
        transform: translateY(2%);
    }
}
</style>
